<template>
  <div class="modal fade" id="proveedorModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            <span v-if="isEditing && proveedor?.descripcion">Editar: {{ proveedor.descripcion }}</span>
            <span v-else>Agregar Proveedor</span>
          </h5>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="submitForm">
            
            <div class="form-group">
              <label>Código</label>
              <input v-model="form.codigo" type="text" 
                class="form-control text-uppercase" 
                :class="{'is-invalid': errors.codigo}"
                placeholder="EJ: PROV-001" 
                :disabled="isEditing" />
              <div class="invalid-feedback">{{ errors.codigo }}</div>
              <small v-if="!isEditing" class="text-muted">Identificador único. Máx 10 caracteres.</small>
            </div>

            <div class="form-group">
              <label>Nombre / Razón Social</label>
              <input v-model="form.descripcion" type="text" 
                class="form-control text-uppercase" 
                :class="{'is-invalid': errors.descripcion}"
                placeholder="EJ: DISTRIBUIDORA POLAR C.A." />
              <div class="invalid-feedback">{{ errors.descripcion }}</div>
            </div>

            <div class="form-group">
              <label>Empresa Asociada</label>
              <select 
                v-model="form.empresa_id" 
                class="form-control" 
                :class="{'is-invalid': errors.empresa_id}"
                :disabled="isEditing">
                <option value="" disabled>Seleccione una empresa</option>
                <option v-for="empresa in empresas" :key="empresa.id" :value="empresa.id">
                  {{ empresa.nombre }}
                </option>
              </select>
              <div class="invalid-feedback">{{ errors.empresa_id }}</div>
            </div>

            <div v-if="isEditing" class="form-group">
                <label>Estatus Operativo</label>
                <div class="custom-control custom-switch">
                    <input type="checkbox" v-model="form.estatus" class="custom-control-input" id="switchEstatus">
                    <label class="custom-control-label" for="switchEstatus">
                        {{ form.estatus ? 'ACTIVO (Operativo)' : 'INACTIVO (No permite compras)' }}
                    </label>
                </div>
                <small class="text-orange" v-if="proveedor?.estatus && !form.estatus">
                    <i class="fas fa-exclamation-triangle"></i> Al desactivar, el sistema verificará que no exista stock pendiente.
                </small>
            </div>

            <div class="modal-footer px-0 pb-0">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
                <button type="submit" class="btn btn-primary">
                    {{ isEditing ? "Actualizar" : "Guardar" }}
                </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/services/api";
import { alert } from "@/plugins/alert.js";
import { loading } from "@/plugins/loading.js";

export default {
  props: ["proveedor", 'empresas'],
  data() {
    return {
      form: this.getDefaultForm(),
      errors: {}
    };
  },
  computed: {
    isEditing() { 
      return !!(this.proveedor && this.proveedor.id); 
    },
  },
  watch: {
    proveedor: {
      immediate: true,
      handler(newVal) {
        this.errors = {};
        if (newVal && newVal.id) {
          this.form = { 
            ...newVal,
            estatus: Boolean(newVal.estatus) // Aseguramos que sea booleano para el switch
          };
        } else {
          this.form = this.getDefaultForm();
        }
      }
    }
  },
  methods: {
    getDefaultForm() {
      return { codigo: "", descripcion: "", empresa_id: "", estatus: true };
    },
    async submitForm() {
      this.errors = {};
      
      // Validaciones básicas de Frontend
      if ((this.form.codigo || "").length < 3) this.errors.codigo = "El código es demasiado corto.";
      if ((this.form.descripcion || "").length < 3) this.errors.descripcion = "La descripción es requerida.";
      if (!this.form.empresa_id) this.errors.empresa_id = "Debe seleccionar una empresa.";

      if (Object.keys(this.errors).length > 0) {
        return alert.toast({ title: 'Revisa los campos', icon: 'warning' });
      }

      try {
        loading.show('Procesando proveedor...');
        const payload = {
          ...this.form,
          codigo: this.form.codigo.trim().toUpperCase(),
          descripcion: this.form.descripcion.trim().toUpperCase(),
          estatus: this.form.estatus
        };

        if (this.isEditing) {
          await api.put(`/proveedor/${this.proveedor.id}`, payload);
        } else {
          await api.post("/proveedor", payload);
        }

        loading.hide();
        alert.toast({ title: '¡Éxito!', icon: 'success' });
        $("#proveedorModal").modal("hide");
        this.$emit("success");

      } catch (error) {
        loading.hide();
        const msg = error.response?.data?.message || 'Error al procesar';
        
        // Manejo especial para la regla de stock del backend (422)
        alert.toast({ title: msg, icon: 'error', timer: 5000 });

        if (error.response?.status === 422) {
          this.errors = error.response.data.errors || {};
        }
      }
    }
  }
};
</script>